export default __webpack_public_path__ + "static/media/alarm-reminder.7b9cca13.svg";